import React from 'react';
import { motion } from 'framer-motion';
import SponsorCards from '../components/SponsorCards';
import Profiles from '../components/Profiles';
import ImpactHighlight from '../components/ImpactHighlight';

export default function Sponsorship() {
  return (
    <div className="bg-white min-h-screen">
      {/* 1. HERO SECTION */}
      <section className="bg-slate-950 pt-44 pb-24 px-6 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-1/3 h-full bg-gh-blue/10 blur-[120px] pointer-events-none"></div>
        <div className="absolute bottom-0 left-0 w-1/4 h-full bg-gh-orange/5 blur-[100px] pointer-events-none"></div>

        <div className="max-w-5xl mx-auto text-center relative z-10">
          <motion.span 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-gh-orange font-black tracking-[0.3em] uppercase text-xs"
          >
            A Future Within Reach
          </motion.span>
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-5xl md:text-7xl font-black text-white mt-6 mb-8 leading-tight"
          >
            Sponsor a <span className="text-gh-orange underline decoration-white/10 underline-offset-[12px]">Child</span>
          </motion.h1>
          <p className="text-slate-400 text-lg md:text-xl font-light max-w-2xl mx-auto leading-relaxed mb-10">
            Your support provides 24/7 care, medical rehabilitation, Basic needs
            and the high-quality education every child deserves.
          </p>
        </div>
      </section>

  <ImpactHighlight />
      {/* 2. SPONSOR TIERS SECTION (Functional PayPal Buttons) */}
      <SponsorCards />

      {/* 3. INDIVIDUAL PROFILES SECTION */}
      <section className="bg-gray-50 border-t border-gray-200 relative">
        <div className="max-w-7xl mx-auto pt-24 text-center px-6">
          <h2 className="text-gh-blue text-4xl font-black mb-4">Meet Our Children</h2>
          <p className="text-gray-500 max-w-xl mx-auto italic">
            "We can change the world one child at a time." — Choose a story below to become their sponsor.
          </p>
        </div>
        
        {/* The Profiles component handles the search and the 92 cards */}
        <Profiles />
      </section>

      {/* 4. BOTTOM CONTACT CTA */}
      <section className="bg-slate-900 py-24 px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h3 className="text-3xl font-bold text-white mb-6 tracking-tight">Need help with sponsorship?</h3>
          <p className="text-slate-400 mb-10 text-lg">
            Our team can walk you through the process or answer any questions about our work in Mityana.
          </p>
          <button className="border-2 border-white text-white px-10 py-4 rounded-full font-bold hover:bg-white hover:text-slate-900 transition-all active:scale-95">
            GET IN TOUCH
          </button>
        </div>
      </section>
    </div>
  );
}